import React from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";

const TextInput = ({ label, value, placeholder, textAlign = 'left', readOnly = false, onChange = () => {},  error }) => {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        inputProps={{
          style: { textAlign: textAlign },
          readOnly: readOnly
        }}
        invalid={!!error} // ถ้ามี error จะเป็น true
      />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  );
};

export default TextInput;
